// extracted by mini-css-extract-plugin
module.exports = {"container":"p_b","oneColumn":"p_X"};